<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center" v-if="checkPermission('AddContrat')">
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          to="/ajouter-contrat">
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          Ajouter un contrat
        </router-link>
        <!-- <button
          class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button" >
          Exporter
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button> -->
      </div>
      <div class="d-flex align-items-center">
       <form class="search-box position-relative me-15" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher un contrat" />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
        <!-- <button
          class="dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block"
          type="button"
        >
          <i class="flaticon-dots"></i>
        </button> -->
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Marchand
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Taux
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                User Max
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Produit Max
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Categorie
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Infos supplémentaire
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
              >ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(contrat, index) in contrats" :key="index">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ contrat?.marchand.nom }} {{ contrat?.marchand.prenom }}   {{ contrat?.marchand.raisonSocial }}
                <!-- {{ contrat?.marchand?.nom + ''}}{{ contrat?.marchand?.prenom }} -->
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ contrat.tauxEconomique }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ contrat.userMax }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ contrat.produitMax }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <div class="col-12">
                    <span v-for="categorie in contrat.categories" :key="categorie.id" class="badge-container">
                      <div class="col-6">
                      <span class="badge badge-outline-danger text-outline-primary">
                        {{ categorie.name }}
                        <a href="javascript:void(0);"
                          class="tag-delete-link text-outline-danger"
                          @click="suppCat(contrat.id,categorie.id)">
                          <i class="flaticon-delete icon-position"></i>
                        </a>
                      </span>
                    </div>
                    </span>
                  </div>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <p v-html="contrat.infosSupplementaire.slice(0, 20) + '...'"></p>
              </td>
              <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0"
              >
              <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                      Actions
                      <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li v-if="checkPermission('AddContratCategorie')">
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#AddNewCategorieModal"
                        @click="openAddNewCategorieModal(contrat)"
                      >
                      <i class="flaticon-plus lh-1 me-8 position-relative top-1"></i>
                        Ajouter de (s) catégorie (s)
                      </a>
                    </li>
                    <li v-if="contrat.urlImage">
                      <a
                        class="dropdown-item d-flex align-items-center" target="_blank" :href="getUrlApiForFiles(contrat.urlImage)" >
                        <i class="flaticon-download lh-1 me-8 position-relative top-1" ></i>
                         Télécharger contrat
                      </a>
                    </li>
                    <li v-if="checkPermission('DeleteContrat')">
                      <a
                        class="dropdown-item d-flex align-items-center" href="javascript:void(0);" @click="suppression(contrat.id,contrats,'contrats',`le contrat de ${contrat.marchand.nom}`)">
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1" ></i>
                         Supprimer
                      </a>
                    </li>
                  </ul>
              </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
      >
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
      </div>
    </div>
  </div>

<AddNewCategorieModal :selectedContrat="selectedContrat" :selectedContratId="selectedContratId" @close="recharger"/>

</template>

<script lang="ts">
import { defineComponent, onMounted, ref} from "vue";
import Swal from "sweetalert2";
import { Contrat } from "../../../models/Contrat";
import ApiService from "../../../services/ApiService";
import { suppression, error, getUrlApiForProductFiles,getUrlApiForFiles, success } from "../../../utils/utils";
import PaginationComponent from '../../../components/Utilities/Pagination.vue';
import JwtService from "../../../services/JwtService";
import AddNewCategorieModal from "./AddNewCategorieModal.vue";
import axios from "axios";

export default defineComponent({
  name: "ListeContrat",
  components: {
    PaginationComponent,
    AddNewCategorieModal,
  },
  setup(){
    
    onMounted(() => {
      getAllContrats();
    });

    const contrats = ref<Array<Contrat>>([]);   
    const contrat = ref<Contrat>();

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllContrats(page_, limit_);
      } catch (error) {
        //
      }
    };

     function rechercher(){
      getAllContrats(page.value, limit.value, searchTerm.value );
    }

   // END PAGINATE

    function getAllContrats(page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/contrats?page=${page}&limit=${limi}&mot=${searchTerm}&`)
      // return ApiService.get('/contrats')
        .then(({ data }) => {
          contrats.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message)
      });
    }

    const success = (message) => {
      Swal.fire({
          text: message,
          toast: true,
          icon: 'success',
          title: 'Message',
          animation: false,
          position: 'top-right',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          heightAuto: false
        });
    };

    function moddifier(EditContrat:Contrat) {
      contrat.value = EditContrat;
    }

    const recharger = () => {
      getAllContrats();
    };

    const deleteContrat = (id: number) => {
      ApiService.delete(`/contrats/${id}`)
      .then(({ data }) => {
        Swal.fire({
          text: data.message,
          toast: true,
          icon: 'success',
          title: 'General Title',
          animation: false,
          position: 'top-right',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          heightAuto: false
        });
      })
      .catch(({ response }) => {
        Swal.fire({
          text: response.data.message,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Réssayer à nouveau!",
          heightAuto: false,
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        });
      });

      for(let i = 0; i < contrats.value.length; i++) {
        if (contrats.value[i].id === id) {
          contrats.value.splice(i, 1);
        }
      }
    };

    // const suppCat = (contratId, categorieId) => {
    //   Swal.fire({
    //   text: "Vous êtes sur le point de faire une suppression",
    //   icon: "warning",
    //   buttonsStyling: true,
    //   showCancelButton: true,
    //   confirmButtonText: "Supprimer",
    //   cancelButtonText: `Annuler`,
    //   heightAuto: false,
    //   customClass: {
    //     confirmButton: "btn btn-danger",
    //   },
    // }).then((result) => {
    //   ApiService.delete(`/contratcategorie/${categorieId}/${contratId}`)
    //     .then(({ data }) => {
    //         Swal.fire({
    //           title: 'Succès',
    //           text: data.message,
    //           icon: "success",
    //           toast: true,
    //           timer: 5000,
    //           position: 'top-right',
    //           showConfirmButton: false,
    //         });
    //         getAllContrats();
    //     }).catch(({ response }) => {
    //       Swal.fire({
    //         text: response.data.message, 
    //         icon: "error",
    //         buttonsStyling: false,
    //         confirmButtonText: "Réssayer à nouveau!",
    //         heightAuto: false,
    //         customClass: {
    //           confirmButton: "btn fw-semobold btn-light-danger",
    //         },
    //       });
    //   });
    //   });
    // }
    // const suppCat = (contratId, categorieId) => {
    //   Swal.fire({
    //   text: "Vous êtes sur le point de faire une suppression",
    //   icon: "warning",
    //   buttonsStyling: true,
    //   showCancelButton: true,
    //   confirmButtonText: "Supprimer",
    //   cancelButtonText: `Annuler`,
    //   heightAuto: false,
    //   customClass: {
    //     confirmButton: "btn btn-danger",
    //   },
    // }).then((result) => {
    //   ApiService.delete(`/contratcategorie/${contratId}/${categorieId}`)
    //     .then(({ data }) => {
    //         Swal.fire({
    //           title: 'Succès',
    //           text: data.message,
    //           icon: "success",
    //           toast: true,
    //           timer: 5000,
    //           position: 'top-right',
    //           showConfirmButton: false,
    //         });
    //         getAllContrats();
    //     }).catch(({ response }) => {
    //       Swal.fire({
    //         text: response.data.message, 
    //         icon: "error",
    //         buttonsStyling: false,
    //         confirmButtonText: "Réssayer à nouveau!",
    //         heightAuto: false,
    //         customClass: {
    //           confirmButton: "btn fw-semobold btn-light-danger",
    //         },
    //       });
    //   });
    //   });
    // }

    const suppCat = (contratId, categorieId) => {
      Swal.fire({
        text: "Vous êtes sur le point de faire une suppression",
        icon: "warning",
        buttonsStyling: true,
        showCancelButton: true,
        confirmButtonText: "Supprimer",
        cancelButtonText: `Annuler`,
        heightAuto: false,
        customClass: {
          confirmButton: "btn btn-danger",
        },
      }).then((result) => {
        if (result.dismiss === Swal.DismissReason.cancel) {
          console.log('Suppression annulée');
        } else if (result.isConfirmed) {
          ApiService.delete(`/contratcategorie/${contratId}/${categorieId}`)
            .then(({ data }) => {
              Swal.fire({
                title: 'Succès',
                text: data.message,
                icon: "success",
                toast: true,
                timer: 5000,
                position: 'top-right',
                showConfirmButton: false,
              });
              getAllContrats();
            }).catch(({ response }) => {
              Swal.fire({
                text: response.data.message, 
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Réessayer à nouveau!",
                heightAuto: false,
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-danger",
                },
              });
            });
        }
      }).catch((error) => {
        console.error('Erreur lors de l\'affichage de la boîte de dialogue', error);
      });
    }

    const selectedContrat = ref<Contrat | undefined>(undefined);
    const selectedContratId = ref<number>();

    const openAddNewCategorieModal = (modele: Contrat) => {
    selectedContrat.value = { ...modele };
    selectedContratId.value = modele.id;
  };
    
    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }

    return { contrats,
      checkPermission,
     getAllContrats,
     deleteContrat,
     moddifier ,
     suppression,
     page, 
    totalPages,
    limit,
    totalElements,
    handlePaginate,
    rechercher,
    searchTerm,
    getUrlApiForProductFiles,
    openAddNewCategorieModal,
    selectedContrat,
    selectedContratId,
    getUrlApiForFiles,
    recharger,
    suppCat,
  };
  },
});
</script>